import React from 'react';

import { Arrow, Line, Marker, Runway } from './Elements';

interface CompassProps {
    angle: number | null;
    minAngle: number | null;
    maxAngle: number | null;
    runwayAngle: number | null;
}

const RADIUS = 490;
const MIN_ANGLE_COLOR = '#999999';
const MAX_ANGLE_COLOR = '#999999';
// const RUNWAY_ANGLE_COLOR = '#FFFF00'

const COMPASS_TEXT_POSITIONS = [
    { value: 'N', x: 470, y: 150 },
    { value: 'S', x: 470, y: 920 },
    { value: 'W', x: 100, y: 530 },
    { value: 'E', x: 870, y: 530 },
];

const Compass: React.FC<CompassProps> = ({ angle, minAngle, maxAngle, runwayAngle }) => (
    <svg viewBox='0 0 1000 1000' preserveAspectRatio='xMinYMin meet' fontSize={80}>
        <circle fill='#EEE' stroke='#083461' strokeWidth={1} cx={500} cy={500} r={RADIUS} />

        {COMPASS_TEXT_POSITIONS.map((item) => (
            <text key={item.value} x={item.x} y={item.y} fill='#083461'>
                {item.value}
            </text>
        ))}
        {[0, 45, 90, 135, 180, 225, 270, 315].map((x) => (
            <Marker key={x} angle={x} color='#083461' />
        ))}

        {typeof runwayAngle === 'number' && <Runway angle={runwayAngle} color='#bab9b9' />}

        {typeof minAngle === 'number' && <Line angle={minAngle} color={MIN_ANGLE_COLOR} />}
        {typeof maxAngle === 'number' && <Line angle={maxAngle} color={MAX_ANGLE_COLOR} />}
        {typeof angle === 'number' && <Arrow angle={angle} />}
        <circle fill='black' strokeWidth={1} cx={500} cy={500} r={20} />
    </svg>
);

export default Compass;
